import gql from 'graphql-tag';

const NAME = 'compositions_reports_createDailyCasesMetricsReportMutation';

export default gql`
  mutation ${NAME} (
    $billable: Boolean,
    $caseNumber: String,
    $customerLocation: String,
    $customerName: String,
    $dealerName: String,
    $endTime: Date!,
    $inboundProgramName: Int,
    $poNumber: String,
    $startTime: Date!,
    $status: [CaseStatus],
    $unitNumber: String,
  ) {
    createDailyCasesMetricsReport(
      filters: {
        billable: $billable,
        caseNumber: $caseNumber,
        customerLocation: $customerLocation,
        customerName: $customerName,
        dealerName: $dealerName,
        endTime: $endTime,
        inboundProgramName: $inboundProgramName,
        poNumber: $poNumber,
        startTime: $startTime,
        status: $status,
        unitNumber: $unitNumber,
      }
    ) {
      jobId
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/Reports/ReportConfigBuilder/withReportActions/createDailyCasesMetricsReportMutation.js